import { createFeatureSelector, createSelector } from "@ngrx/store";
import { UserProfileState } from "./user-profile.state";
import { StoreConstants } from "src/app/constants/StoreConstants";
import { Userprofile } from "src/app/_models/Userprofile";
import { Organisation } from "src/app/_models/Organisation";
import { InformationHeader } from "src/app/_models/InformationHeader";
import { Roles } from "src/app/constants/Roles";
import { Centre } from "src/app/_models/Centre";
import { Group } from "src/app/_models/Group";

export const selectUserProfileState = createFeatureSelector<UserProfileState>(
  StoreConstants.STATE_UPS
);

export const selectOwnUserProfile = createSelector(
  selectUserProfileState, 
  (state: UserProfileState): Userprofile => state.userProfile
);

export const selectUserRole = createSelector(
  selectUserProfileState,
  (state: UserProfileState): Roles  => state.userProfile?.roleId
);

export const selectUserOrganisation = createSelector(
  selectUserProfileState,
  (state: UserProfileState): Organisation[] => state.userProfile?.organisationList
);

export const selectUserInformationHeaders = createSelector(
  selectUserProfileState,
  (state: UserProfileState): InformationHeader => state.informationHeader
);

export const selectOwnUserProfileLoader = createSelector(
  selectUserProfileState,
  (state: UserProfileState): boolean => state.loading
);

export const selectProfile = createSelector(
  selectUserProfileState,
  (state: UserProfileState): Userprofile => state.profile
);

export const selectUserHasAccessToLearner = createSelector(
  selectUserProfileState,
  (state: UserProfileState): boolean => state.hasAccessToLearner
);

export const selectUserHasAccessToLearnerLoader = createSelector(
  selectUserProfileState,
  (state: UserProfileState): boolean => state.hasAccessToLearnerLoader
);

export const selectUserCentre = createSelector(
  selectUserProfileState,
  (state: UserProfileState): Centre[] => state.userProfile?.userCentres
);

export const selectUserGroup = createSelector(
  selectUserProfileState,
  (state: UserProfileState): Group[] => state.userProfile?.userGroup
);